import React from "react";
import { Box, Typography } from "@mui/material";
import FormButton from "../FormButton";
import { useTranslation } from "../../hooks/useTranslation";

interface InjuryStepProps {
  treatedBy: string;
  onChange: (field: string, value: string) => void;
}

const InjuryStep: React.FC<InjuryStepProps> = ({ treatedBy, onChange }) => {
  const { t } = useTranslation();
  return (
    <>
      <Typography variant="h6" align="center" sx={{ color: "#c6c6c6", mb: 2 }}>
        Question 1 out of 5
      </Typography>
      <Typography variant="h6" align="center" sx={{ mb: 3 }}>
        1. {t("form.firstQuestion.question")}
        <span style={{ color: "red" }}>*</span>
      </Typography>

      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <FormButton
          isSelected={treatedBy === "YES"}
          onClick={() => {
            onChange("treatedBy", "YES");
            onChange("physicalInjury", "YES");
          }}
        >
          {t("form.firstQuestion.option1")}
        </FormButton>

        <FormButton
          isSelected={treatedBy === "NO"}
          onClick={() => {
            onChange("treatedBy", "NO");
            onChange("physicalInjury", "NO");
          }}
        >
          {t("form.firstQuestion.option2")}
        </FormButton>
      </Box>
    </>
  );
};

export default InjuryStep;
